import React from "react";

export default function SectionHeader({ eyebrow, title, kicker, align = "left", as: Heading = "h2", children }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid="section-header">
      {eyebrow && (
        <div className="text-[11px] md:text-xs tracking-[.28em] uppercase text-burgundy font-medium mb-4 flex items-center gap-3">
          {align === "center" && <span className="hidden md:block h-px w-8 bg-gold/60" />}
          <span>{eyebrow}</span>
          {align !== "center" && <span className="hidden md:block h-px w-8 bg-gold/60" />}
        </div>
      )}
      {title && (
        <Heading className="font-serif font-light text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-charcoal">
          {title}
        </Heading>
      )}
      {kicker && <p className="mt-5 text-base md:text-lg text-charcoal/75 leading-relaxed">{kicker}</p>}
      {children}
    </div>
  );
}
